import { DateUtils } from '@homeleite/common-utils';
import { MilkedAnimal } from '../../animals';
import { Status } from '../status.enum';
import { Id } from '@homeleite/arch';
import { DomainEntity, Json } from '@homeleite/arch';

export class Milking implements DomainEntity {
    constructor(
        public readonly id: string = Id.gen(),
        public startedAt: Date = null,
        public finishedAt: Date = null,
        public milkedAnimals: MilkedAnimal[] = [],
        public status: string = Status.OPEN,
        public positions = 0,
        public lot: string = null,
        public milkingNumber = 1
    ) {}

    get totalMilkedCows(): number {
        return this.milkedAnimals.length;
    }

    get totalMilkedVolume(): number {
        if (!this.milkedAnimals || this.milkedAnimals.length === 0) {
            return 0;
        }

        return this.milkedAnimals.reduce((acc, mc) => acc + (mc.production || 0), 0);
    }

    get hasFinished(): boolean {
        return this.status == Status.CLOSED && this.finishedAt != null;
    }

    get totalMilkedAnimals(): number {
        return this.milkedAnimals?.length || 0;
    }

    toJson(): any {
        return Json.to.simple(this, {
            startedAt: this.startedAt?.toISOString() ?? null,
            finishedAt: this.finishedAt?.toISOString() ?? null,
            milkedAnimals: this.milkedAnimals?.map(animal => animal.toJson()) ?? null
        });
    }

    static fromJson(json?: any): Milking {
        return json
            ? Json.from.simple(json, Milking, {
                startedAt: json.startedAt
                    ? (typeof json.startedAt === 'string'
                        ? DateUtils.parseLocalDateTimeWithSeconds(json.startedAt)
                        : json.startedAt
                    )
                    : null,
                finishedAt: json.finishedAt
                    ? (typeof json.finishedAt === 'string'
                        ? DateUtils.parseLocalDateTimeWithSeconds(json.finishedAt)
                        : json.finishedAt
                    )
                    : null,
                milkedAnimals: json.milkedAnimals
                    ? Json.from.array(json.milkedAnimals, MilkedAnimal.fromJson)
                    : null
            })
            : null;
    }
}
